var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcReadmore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.234375C3.48633 0.234375 0.234375 3.48633 0.234375 7.5C0.234375 11.5137 3.48633 14.7656 7.5 14.7656C11.5137 14.7656 14.7656 11.5137 14.7656 7.5C14.7656 3.48633 11.5137 0.234375 7.5 0.234375ZM11.7188 8.32031C11.7188 8.51367 11.5605 8.67188 11.3672 8.67188H8.67188V11.3672C8.67188 11.5605 8.51367 11.7188 8.32031 11.7188H6.67969C6.48633 11.7188 6.32812 11.5605 6.32812 11.3672V8.67188H3.63281C3.43945 8.67188 3.28125 8.51367 3.28125 8.32031V6.67969C3.28125 6.48633 3.43945 6.32812 3.63281 6.32812H6.32812V3.63281C6.32812 3.43945 6.48633 3.28125 6.67969 3.28125H8.32031C8.51367 3.28125 8.67188 3.43945 8.67188 3.63281V6.32812H11.3672C11.5605 6.32812 11.7188 6.48633 11.7188 6.67969V8.32031Z",
    fill: "#3E8181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReadmore);
export default __webpack_public_path__ + "static/media/ic_readmore.6fe589b7c1964842c66faccb63b89eaa.svg";
export { ForwardRef as ReactComponent };